<template>
  <el-col class="content" style="padding: 10px;">
    <el-button class="hidden-sm-and-up navbar-toggler" @click="left_show = !left_show, right_show=true, l_show()" plain>
      <i v-if="left_show" class="el-icon-s-unfold"></i>
      <i v-else class="el-icon-caret-top"></i>
    </el-button>
    <router-link to="/home" active-class="false">
      <img class="logo" src="/static/d6ef8ba3a05f4d63560d394773bbca32.png">
    </router-link>
    <el-button class="hidden-sm-and-up navbar-toggler" @click="right_show = !right_show, left_show=true, r_show()" plain>
      <i v-if="right_show" class="el-icon-user-solid"></i>
      <i v-else class="el-icon-caret-top"></i>
    </el-button>
    <div class="collapse justify-content-between hidden-xs-only">
      <div class="hidden-xs-only">
        <router-link to="/lists" class="navbar-nav">信息</router-link>
        <router-link to="/merchant" class="navbar-nav">商家</router-link>
        <router-link to="/publish" class="navbar-nav">发布</router-link>
        <router-link to="/upgrade" class="navbar-nav">VIP</router-link>
        <router-link to="/help" class="navbar-nav"> 帮助</router-link>
      </div>
      <div class="hidden-sm-and-down">
        <search></search>
      </div>
    </div>
    <div class="collapse justify-content-end hidden-xs-only">
      <router-link v-if="!this.$store.getters.Flag" to="/login" class="navbar-nav">登录</router-link>
      <router-link v-if="!this.$store.getters.Flag" to="/registered" class="navbar-nav">注册</router-link>
      <router-link active-class v-if="this.$store.getters.Flag" to="/usercenter" class="navbar-nav right-nav">
        <svg-icon icon-class="user"></svg-icon>会员中心</router-link>
    </div>

  </el-col>
</template>

<script>
import search from '../../widget/search'
import axios from 'axios'
export default {
  name: 'Nav',
  data () {
    return {
      left_show: true,
      right_show: true
    }
  },
  computed: {

  },
  methods: {
    l_show () {
      this.$emit('left_show', this.left_show)
      this.$emit('right_show', this.right_show)
    },
    r_show () {
      this.$emit('left_show', this.left_show)
      this.$emit('right_show', this.right_show)
    },
    out () {
      axios({
        url: '/api/out',
        methods: 'get'
      }).then(function (res) {
        if (res.data['status'] === 0) {
          localStorage.removeItem('promote')
          this.$store.commit('promote', localStorage.getItem('promote'))
          localStorage.removeItem('Flag')
          this.$store.commit('Flag', localStorage.getItem('Flag'))
          localStorage.removeItem('proxy')
          this.$store.commit('proxy', localStorage.getItem('proxy'))
          this.$message.success({
            message: '成功退出'
          })
          location.reload()
        }
      }.bind(this))
    }
  },
  components: {
    search
  }
}
</script>

<style scoped>
  .content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .navbar-toggler {
    padding: .4rem .75rem;
    font-size: 1.5rem;
  }
  .navbar-nav {
    padding: 24px 24px 24px 24px;
    color: black;
    text-decoration: none;
    border-bottom: 3px solid rgba(0, 0, 0, 0);
    flex-basis: auto;
  }

  .active {
    color: #f39;
    border-bottom: 3px solid #f39;
  }

  .logo {
    height: auto;
    width: 120px;
  }

  .collapse {
    display: flex;
    flex-basis: auto;
    flex-grow: 1;
    align-items: center;
    height: 100%;
  }
  .justify-content-end {
    justify-content: flex-end !important;
  }

  .justify-content-between {
    justify-content: space-between !important;
  }
  .right-nav{
    font-size: 14px;
  }
  .svg-icon {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    margin-right: 3px;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/header/Nav.vue